import * as Sentry from '@sentry/react';
import { Modal } from 'cpool-components/general/Modal';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuCircleX, LuCloudUpload } from 'react-icons/lu';
import { toast } from 'react-toastify';

type Props = {
    documentNames: string[];
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
};

export const TransferDocumentsDialog: React.FC<Props> = ({ documentNames, onClose, onConfirm, open }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('OFFER_MANAGEMENT.TRANSFER_DOCUMENTS.TITLE')}
            panelClassName="max-w-md"
        >
            <div className="flex flex-col gap-4 text-14 text-midnight">
                <p>{t('OFFER_MANAGEMENT.TRANSFER_DOCUMENTS.DESCRIPTION')}</p>
                {documentNames.length > 0 ? (
                    <ul className="list-disc pl-5">
                        {documentNames.map((name) => (
                            <li key={name} className="font-bold">
                                {name}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-grey">{t('OFFER_MANAGEMENT.TRANSFER_DOCUMENTS.NO_DOCUMENTS')}</p>
                )}
                <p>{t('OFFER_MANAGEMENT.TRANSFER_DOCUMENTS.HINT')}</p>
                <div className="flex items-center justify-end gap-2">
                    <Button
                        variant={ButtonVariant.SECONDARY}
                        iconLeft={<LuCircleX className="h-4 w-4" />}
                        onClick={onClose}
                    >
                        {t('BUTTONS.CANCEL')}
                    </Button>
                    <Button
                        disabled={documentNames.length === 0}
                        iconLeft={<LuCloudUpload className="h-4 w-4" />}
                        onClick={() => {
                            onConfirm().catch((error) => {
                                Sentry.captureException(error);
                                toast.error(t('TOAST.ERROR_OCCURRED'));
                            });
                            onClose();
                        }}
                    >
                        {t('OFFER_MANAGEMENT.ICONS_TOOLTIP.TRANSFER_TO_BANK')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
